module.exports = __webpack_public_path__ + "img/Target_Icon.64ac65fb.svg";